import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/workflows`;
export const list    = (wsId)               => get(base(wsId));
export const catalog = (wsId)               => get(`${base(wsId)}/event-catalog`);
export const history = (wsId, wfId)         => get(`${base(wsId)}/history${wfId ? '?workflowId=' + wfId : ''}`);
export const create  = (wsId, body)         => post(base(wsId), body);
export const getOne  = (wsId, id)           => get(`${base(wsId)}/${id}`);
export const update  = (wsId, id, body)     => patch(`${base(wsId)}/${id}`, body);
export const remove  = (wsId, id)           => del(`${base(wsId)}/${id}`);
export const trigger = (wsId, id, body)     => post(`${base(wsId)}/${id}/trigger`, body);
